import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { Expenses } from '@/features/expenses'

const expensesSearchSchema = z.object({
  page: z.number().optional().catch(1),
  limit: z.number().optional().catch(20),
  status: z
    .enum(['draft', 'submitted', 'approved', 'rejected', 'paid'])
    .optional(),
  category: z
    .enum([
      'fuel',
      'meals',
      'supplies',
      'parking',
      'transport',
      'medical_supplies',
      'equipment',
      'other',
    ])
    .optional(),
  staffId: z.string().optional(),
  startDate: z.string().optional(),
  endDate: z.string().optional(),
})

export const Route = createFileRoute(
  '/_authenticated/_organization/expenses/'
)({
  validateSearch: expensesSearchSchema,
  component: Expenses,
})
